/*
 * Its own module to break a cycle: `code-block.ts` needs the node view, and the
 * node view needs this list to build its picker. Importing it back off
 * `code-block.ts` worked only because the read happens at render time rather
 * than at module evaluation — a fragile thing to leave load-bearing, and it
 * confused editor tooling into reporting the node-view import as unresolvable.
 */

/**
 * An explicit language set rather than lowlight's `common` bundle: `common`
 * drags ~35 grammars into every app that imports `@opero/ui`, and this editor
 * ships in three of them.
 */
export const CODE_LANGUAGES = [
  { value: "plaintext", label: "Plain text" },
  { value: "typescript", label: "TypeScript" },
  { value: "javascript", label: "JavaScript" },
  { value: "tsx", label: "TSX" },
  { value: "json", label: "JSON" },
  { value: "bash", label: "Shell" },
  { value: "python", label: "Python" },
  { value: "go", label: "Go" },
  { value: "java", label: "Java" },
  { value: "csharp", label: "C#" },
  { value: "sql", label: "SQL" },
  { value: "css", label: "CSS" },
  { value: "xml", label: "HTML / XML" },
  { value: "yaml", label: "YAML" },
  { value: "markdown", label: "Markdown" },
  { value: "php", label: "PHP" },
  { value: "ruby", label: "Ruby" },
  { value: "rust", label: "Rust" },
] as const;
